import React, { useState } from "react";
import Breadcrumb from "../components/Reusable/Breadcrumb";
import { Col, Row } from "react-bootstrap";
import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import { useDispatch } from "react-redux";
import { changePassword } from "../actions/security";
import { toast } from "react-toastify";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";
import { t } from "i18next"; // Import t function for translation
import { Visibility, VisibilityOff } from "@mui/icons-material";

const ChangePassword = () => {
  const [data, setData] = useState({
    newPassword: "",
    oldPassword: "",
    rePassword: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [passwordConditions, setPasswordConditions] = useState({
    uppercase: false,
    minLength: false,
    number: false,
    specialChar: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setData((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleToggleRePassword = () => {
    setShowRePassword((prev) => !prev);
  };
  const handleToggleOldPassword = () => {
    setShowOldPassword((prev) => !prev);
  };

  const handlePasswordChange = (event) => {
    handleInputChange(event);
    if (event.target.name === "newPassword") {
      validatePassword(event.target.value);
    }
  };

  const validatePassword = (password) => {
    const uppercaseRegex = /[A-Z]/;
    const numberRegex = /\d/;
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

    setPasswordConditions({
      uppercase: uppercaseRegex.test(password),
      minLength: password.length >= 8,
      number: numberRegex.test(password),
      specialChar: specialCharRegex.test(password),
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (data.newPassword !== data.rePassword) {
      toast.error(t("changePassword.passwordMismatchError"), {
        theme: "colored",
      });
      return;
    }
    if (
      !passwordConditions.uppercase ||
      !passwordConditions.minLength ||
      !passwordConditions.number ||
      !passwordConditions.specialChar
    ) {
      toast.error(t("changePassword.passwordRequirementsError"), {
        theme: "colored",
      });
      return;
    }

    dispatch(changePassword(data, navigate));
  };

  return (
    <div className="change-password-main-container">
      <Breadcrumb
        title={t("changePassword.breadcrumbTitle")}
        returnPage="/settings"
      />

      <div className="change-password-content">
        <Row>
          <form onSubmit={handleSubmit}>
            <Col xs={12}>
              <TextField
                type={showOldPassword ? "text" : "password"}
                variant="standard"
                required
                label={t("changePassword.oldPasswordLabel")}
                name="oldPassword"
                value={data.oldPassword}
                onChange={handlePasswordChange}
                fullWidth
                size="small"
                className="input-field-form mb-3"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleToggleOldPassword} edge="end">
                        {showOldPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Col>
            <Col xs={12}>
              <TextField
                type={showPassword ? "text" : "password"}
                variant="standard"
                required
                label={t("changePassword.newPasswordLabel")}
                name="newPassword"
                value={data.newPassword}
                onChange={handlePasswordChange}
                fullWidth
                size="small"
                className="input-field-form mb-3"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleTogglePassword} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Col>
            <Col xs={12} className="passowrd-holder-item">
              <TextField
                type={showRePassword ? "text" : "password"}
                variant="standard"
                required
                label={t("changePassword.rePasswordLabel")}
                name="rePassword"
                value={data.rePassword}
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form mb-3"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleToggleRePassword} edge="end">
                        {showRePassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <div className="holder-password-required-items mt-3">
                <div className="info-password-required">
                  <div
                    className={`info-password-required-text ${
                      passwordConditions.uppercase
                        ? "check-required-success"
                        : ""
                    }`}
                  >
                    <CheckIcon /> {t("changePassword.passwordCondition1")}
                  </div>
                  <div
                    className={`info-password-required-text ${
                      passwordConditions.minLength
                        ? "check-required-success"
                        : ""
                    }`}
                  >
                    <CheckIcon /> {t("changePassword.passwordCondition2")}
                  </div>
                  <div
                    className={`info-password-required-text ${
                      passwordConditions.number ? "check-required-success" : ""
                    }`}
                  >
                    <CheckIcon /> {t("changePassword.passwordCondition3")}
                  </div>
                  <div
                    className={`info-password-required-text ${
                      passwordConditions.specialChar
                        ? "check-required-success"
                        : ""
                    }`}
                  >
                    <CheckIcon /> {t("changePassword.passwordCondition4")}
                  </div>
                </div>
              </div>
            </Col>
            <div className="button-change-password-holder">
              <Button type="submit" fullWidth size="small">
                {t("changePassword.submitButtonText")}
              </Button>
            </div>
          </form>
        </Row>
      </div>
    </div>
  );
};

export default ChangePassword;
